import styles from "../css/reverseStock.module.css";
import FormInput from "../../../../components/FormInput.jsx";

export default function Filters({ fromDate, setFromDate, toDate, setToDate }) {
  return (
    <div className={styles.dateFiltersCard}>
      <div className={styles.dateFiltersRow}>
        <div className={styles.inlineFilter}>
          <span>From</span>
          <FormInput
            label=""
            type="date"
            name="reverseFromDate"
            value={
              fromDate instanceof Date
                ? fromDate.toISOString().slice(0, 10)
                : fromDate || ""
            }
            onChange={(e) => {
              const val = e.target.value;
              setFromDate(val ? new Date(val) : null);
            }}
          />
        </div>
        <div className={styles.inlineFilter}>
          <span>To</span>
          <FormInput
            label=""
            type="date"
            name="reverseToDate"
            value={
              toDate instanceof Date
                ? toDate.toISOString().slice(0, 10)
                : toDate || ""
            }
            onChange={(e) => {
              const val = e.target.value;
              setToDate(val ? new Date(val) : null);
            }}
          />
        </div>
      </div>
    </div>
  );
}
